import type { ReactNode } from 'react';
import { usePermission, usePermissions } from '@/lib/permissions';

interface PermissionGateProps {
  permission: string | string[];
  mode?: 'all' | 'any';
  fallback?: ReactNode;
  children: ReactNode;
}

export function PermissionGate({
  permission,
  mode = 'all',
  fallback = null,
  children,
}: PermissionGateProps) {
  const single = typeof permission === 'string';
  const hasSingle = usePermission(single ? permission : '');
  const hasMultiple = usePermissions(single ? [] : permission, mode);

  const hasAccess = single ? hasSingle : hasMultiple;

  return hasAccess ? <>{children}</> : <>{fallback}</>;
}
